import React from 'react';

import HeaderUserBox from './Userbox';

interface SidebarFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  collapsed?: boolean;
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ collapsed }) => {
  return (
    <div>
      {collapsed ? (
        <HeaderUserBox collapsed={!!collapsed} />
      ) : (
        <div style={{ marginTop: '16px' }}>
          <HeaderUserBox collapsed={!!collapsed} />
        </div>
      )}
    </div>
  );
};
